module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("L")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ennonism")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ARIQ")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LI")])])])]), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/footnote#footnote2",
      "id": "fn2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("UR FIRST DIRECT CONTACT IN 1969 WAS FORMAL.")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WAS EDITING THE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LACK")]), _vm._v(" D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WARF,")])]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A RADICAL POLITICO-CULTURAL MAGAZINE.")]), _vm._v(" W"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E HAD PUBLISHED")]), _vm._v(" “A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("N")]), _vm._v(" O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("PEN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ETTER TO")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENNON”—A SAVAGE REVIEW OF THE")]), _vm._v(" Beatles’ album "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revolution")]), _vm._v(" by John Hoyland, our music/popular culture critic. John Lennon had been busted by the cops. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Dwarf")]), _vm._v(" used the occasion to discuss the lyrics of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revolution")]), _vm._v(" album seriously. Hoyland wrote:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Above all: perhaps now you’ll see what it is you’re (we’re) up against. Not nasty people, not even neurosis or spiritual undernourishment. What we’re confronted with is a repressive, vicious, authoritarian system. A system which is inhuman and immoral, because it deprives 99 percent of humanity of the right to live their lives their own way. A system which will screw you if you step out of line and behave just a tiny bit differently from the way those in power want.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Such a system—such a society—is so racked by contradiction and tension and unhappiness that all relationships within it are poisoned. You know this. You know, from your own experience, how little control over their lives working-class people are permitted to have…. How can love and kindness between human-beings grow in such a society? It can’t. Don’t you see that now? The system has got to be changed before people can live the full, loving lives that you have said you want.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now do you see what was wrong with your record Revolution? That record was no more revolutionary than Mrs. Dale’s Diary. In order to change the world we’ve got to understand what’s wrong with the world. And then, destroy it. Ruthlessly…. There is no such thing as a polite revolution.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The tone of the letter was undoubtedly patronizing, and we thought he would ignore it. But a week later he sent a reply to John Hoyland with a covering note hoping I would publish it. We did:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who do you think you are? What do you think you know? I’m not only up against the establishment but you, too, it seems. I know what I’m up against—narrow minds—rich/poor. All your relationships may be poisoned—it depends how you look at it. What kind of system do you propose and who would run it?")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I don’t remember saying")]), _vm._v(" Revolution "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was revolutionary—fuck Mrs. Dale. Listen to all three versions (Revolution 1, 2 and 9) then try again, dear John….")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You’re obviously on a destruction kick. I’ll tell you what’s wrong with the world—people, so do you want to destroy them? Ruthlessly? Until we change your/our heads—there’s no chance. Tell me of one successful revolution. Who fucked up Communism…? Sick Heads and nothing else. Do you think all the enemy wear capitalist badges so that you can shoot them? It’s a bit naïve, John. You seem to think it’s just a class war….")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Look man, I was/am not against you. Instead of splitting hairs about the Beatles and the Stones—think a little bigger—look at the world we’re living in and ask yourself: why? And then—come and join us.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Love,")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("John Lennon")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "extractText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PS—You smash it—I’ll build around it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As these extracts suggest, it was a spirited exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After that there was a long silence. And, as was also common in those days, there was soon a split in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Dwarf.")]), _vm._v(" How strange it seems now and how stupid and destructive, but that’s the way we were. The Leninists left to set up "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Red Mole")]), _vm._v(" and moved from swinging Soho to proletarian Pentonville Road, a seedy zone near Kings Cross station in London.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One day John rang and we talked. He suggested a meeting and a week later he and Yoko showed up at my bed-sit in North London with a delicious Japanese take-away as supper. We discussed the state of the world, including the state of the student movement in Japan. John’s views had sharpened considerably since the letters in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Black Dwarf.")]), _vm._v(" He told me that, like Mick Jagger, he had wanted to march on the big anti-Vietnam war demos but the Beatles’ manager, Brian Epstein, had forbidden any such outing. Epstein was fearful that the group might be denied visas to the States, which would be a commercial disaster. John always regretted having obeyed his manager, but that was in the past. The biggest and best influence in his life was now Yoko Ono. I was in no doubt that Yoko had radicalized him further on the artistic and the political front. She had also been accused of breaking up the Beatles and we laughed a great deal at the suggestion. He was angered by the racist gibes against Yoko in the tabloid press. I suggested they should be taken as compliments. It would be awful if the creeps who attacked her decided to turn their coats. Before they left, I suggested an interview with both of them and he agreed, wondering aloud whether it would be appropriate since “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Red Mole")]), _vm._v(" was very serious and interviewing me might lower the tone.” He wasn’t joking, but I assured him that an interview would be enormously helpful for our little newspaper. I asked if I could bring my colleague Robin Blackburn—more attuned to popular culture than myself—to which he readily agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A week later, a large limo pulled up outside our offices to the astonishment of bystanders. Robin and I piled in and were driven to Tittenhurst. We spoke for most of the day, saw one of Yoko’s avant-garde films (which Robin Blackburn simply adored) and were driven back to London. The interview had gone extremely well. Both John and Yoko had been disarmingly frank. All that was now left was the editing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The very next morning John rang. He had been so inspired by our interview that he had written a new song. Could he sing it on the phone? He could. That was how I first heard “Power to the People.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We met several times after that, sometimes before a recording session at the Abbey Road Studios, more often at Tittenhurst. Robin and I took a French friend, Régis Debray, to one of these sessions. I first heard the words of “Imagine” at the kitchen table in Tittenhurst.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The Politburo approves, John,” I joked at the time, wondering whether I would have been in a minority on the Politburo on this question. His lyrics had moved beyond matrimonial moonings. Love and happiness now became a feminist call for a new way of life. Here again, Yoko’s influence was visible. The fantastic, as well as the surreal, were given a rest. Lennon, as Epstein feared, had become ultrasubversive and political. “Working Class Hero” and “The Luck of the Irish” did not please the conservative critics, but were enormously popular.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was on one of these visits to Tittenhurst that he told me how fed up they were with England. It was too parochial and racist, Yoko hated it and so did he and they were moving to New York. I could understand all this, but did warn him that there were too many kooks in that country and he should be careful. During his first year in New York we spoke on the phone, but soon lost touch. Computers, alas, had not yet been invented.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Together with the rest of the world, one felt a great deal of pain the day he died. I think the tribute he would have loved was the spontaneous grief in Moscow as kids rushed to the Lenin Hills and sang “Back in the U.S.S.R.” I thought of him during the giant global demonstrations against the Bush-Blair war on Iraq. His spirit was marching with us.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ad4904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 75
// module chunks = 0